<form
  class="row-form"
  [formGroup]="websiteLinkFormGroup()"
>
  @for (field of websiteLinkFormFields; track $index) {
    <mat-form-field
      appearance="outline"
      class="row-form-field"
      [class]="getFormFieldClass()"
      [style.cursor]="websiteLinkData().id && 'pointer'"
      (click)="handleValueClick(field.fieldName)"
    >
      <mat-label>{{ field.label }}</mat-label>
      <input
        matInput
        [readonly]="!!websiteLinkData().id"
        [formControlName]="field.fieldName"
      >
    </mat-form-field>
  }
</form>
<div class="row-buttons">
  @if (!websiteLinkData().id) {
    @if (noFirstData()) {
      <button
        mat-icon-button
        class="row-btn"
        (click)="handleClick('delete')"
      >
        <mat-icon class="row-btn-icon">delete</mat-icon>
      </button>
    }
    <button
      mat-icon-button
      class="row-btn"
      [disabled]="!websiteLinkFormGroup().valid"
      (click)="handleClick('save')"
    >
      <mat-icon class="row-btn-icon">save</mat-icon>
    </button>
  } @else {
    <button
      mat-icon-button
      class="row-btn"
      (click)="handleClick('history')"
    >
      <mat-icon class="row-btn-icon">info</mat-icon>
    </button>
    @if (isEditModeActive()) {
      <button
        mat-icon-button
        class="row-btn"
        (click)="handleClick('deleteCurrent')"
      >
        <mat-icon class="row-btn-icon">delete</mat-icon>
      </button>
    }
  }
</div>
